// Extract unique set of words from a string, for natural comparison/searching
export function generateWords(text: string): Set<string> {
  let wordsArray = text
    .toLowerCase()
    .replace(/[^a-z0-9]/g, ' ')
    .replace(/ +/g, ' ')
    .trim()
    .split(' ');
  return new Set<string>(wordsArray);
}

// Extract unique set of trigrams from a string, for natural comparison/searching
export function generateTrigrams(text: string): Set<string> {
  text = text
    .toLowerCase()
    .replace(/[^a-z0-9]/g, ' ')
    .replace(/ +/g, '  ');

  text = '  ' + text + '  ';

  let trigrams = new Set<string>();
  for (let i = 0; i < text.length - 2; i++) {
    let trigram = text.substr(i, 3);
    trigrams.add(trigram);
  }

  return trigrams;
}

/** Calculates the trigram matching score. Higher means closer match. Asymptotic into 1.0.
 * Note: it might run a tad faster if b is shorter than a.
 */
export function calculateTrigramMatching(a: Set<string>, b: Set<string>) {
  let intersectionSize = 0;
  for (let t of b) {
    if (a.has(t)) {
      intersectionSize++;
    }
  }

  let unionSize = a.size + b.size - intersectionSize;
  return intersectionSize / unionSize;
}

/** Calculates the asymmetric trigram matching score. Higher means more of search string is represented asymptotic into 1.0 when whole.
 */
export function calculateAsymTrigramMatching(search: Set<string>, candidate: Set<string>) {
  let intersectionSize = 0;
  if (!candidate) {
    return 0;
  }
  for (let t of search) {
    if (candidate.has(t)) {
      intersectionSize++;
    }
  }

  return (intersectionSize * 2) / (search.size + candidate.size);
}
